import './index.scss'          

$(document).ready(function(){
  if($('.ny-banner').length > 0){
    $('.ny-banner').addClass('active')
  }
})
$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度

  // banner位移效果
  if($('.ny-banner').length > 0){
    $('.ny-banner .bg').css({
      'transform':'translateY('+ scroH / 3 +'px)'
    })
  }
  
})